import { Component } from "@angular/core";
import { Four51Service } from "../four51.service";
import { ApiService } from "../api.service";

@Component({
    selector: 'app-lookup',
    templateUrl: './lookup.component.html',
    styleUrls: ['./lookup.component.scss']
  })

  export class LookupComponent {
    orderNumber = '';
    order: any = null;
    variantId = '';
    constructor(private four51Service: Four51Service, private apiService: ApiService) {}

    async lookupOrder() {
        // const response: any = await this.four51Service.getOrderByNumber(this.orderNumber).toPromise();
        // const orderListItem = response.List[0];
        // this.order = await this.four51Service.getOrderById(orderListItem.ID).toPromise();
        
    }

    async generateArt() {
        if (this.variantId) {
            try {
                const softReturn = String.fromCharCode(8232);
                const variant = await this.apiService.getVariant(this.variantId).toPromise();
                if (variant) {
                  const templateData = {};
                  for (var key in variant.Specs) {
                    if (variant.Specs.hasOwnProperty(key)) {

                      if (variant.ProductInteropID === 'MDVIP-Invitation') {

                        if (key === 'long_description_html') {
                          templateData[key] = variant.Specs[key].Value ? variant.Specs[key].Value.replace(/\[Column Break\]/g, '</p><p class="column-break">') : '';
                        } else if (['patient_guests', 'logo', 'cobrand'].includes(key)) {
                          templateData[key] = variant.Specs[key].Value ? variant.Specs[key].Value.replace('.pdf', '') : '';
                        } else if (['event_date_text', 'additionalInformation'].includes(key)) {
                          templateData[key] = variant.Specs[key].Value ? variant.Specs[key].Value.replace(softReturn,  '<br>') : '';
                        } else {
                          templateData[key] = variant.Specs[key].Value;
                        }

                      } else {

                        if (['V10Certifications', 'V11Medical_School', 'V12Hospital_Affiliations'].includes(key)) {
                          templateData[key] = variant.Specs[key].Value.replace(/\r?\n/g, '<br>')
                        } else {
                          templateData[key] = variant.Specs[key].Value;
                        }

                      }
                      
                    }

                  }
                  const body = {
                      templateUrl: this.getTemplateUrl(variant.ProductInteropID),
                      data: templateData,
                      width: 8.5,
                      height: 11.0
                  };

                  if (variant.ProductInteropID === '0DDDF4AD-998C-4567-A56D-5E11EB7909E2') {
                      body.width = 17;
                      body.height = 11;
                  }

                  if (variant.ProductInteropID === '83D31E03-F16E-4FE2-923A-59FFE07C2A8F') {
                    body.width = 11.25;
                    body.height = 5.75;
                  }

                  if (variant.ProductInteropID === 'A2C21292-3572-44B7-8CEB-F6929DB254FF') {
                    body.width = 4;
                    body.height = 9;
                  }

                  if (variant.ProductInteropID === '49D4F31D-1A5B-435F-9094-070063F47B26' || 
                      variant.ProductInteropID === 'MD52410' ||
                      variant.ProductInteropID === 'MD64612') {
                    body.width = 4;
                    body.height = 7;
                  }

                  if (variant.ProductInteropID === 'A678D8E2-AD56-4B10-BB5B-08142796E227') {
                    body.width = 5.5;
                    body.height = 8;
                  }

                  const pdfResponse = await this.apiService.getPdf(body).toPromise();
                  window.open(pdfResponse.url, '_blank');
                }
                  
            } catch (error) {
                console.error('Error fetching variant:', error);
            }
        } else {
            console.warn('Variant ID is empty');
        }
    }

    getTemplateUrl(InteropID: string): string {
    switch (InteropID) {
      case '0DDDF4AD-998C-4567-A56D-5E11EB7909E2':
        // Heart Disease/Stroke Handout
        // MD.51357
        return 'https://mdvipsf.seprint.com/assets/pdf-gen/templates/md-51357.html';
      case '82E756E2-5D8B-441B-B281-473853AFE714':
        // Pre-Wellness Checklist
        // MD.61367
        return 'https://mdvipsf.seprint.com/assets/pdf-gen/templates/md-61367.html';
      case '83D31E03-F16E-4FE2-923A-59FFE07C2A8F':
        // Annual Wellness Reminder Postcard
        // MD.64554
        return 'https://mdvipsf.seprint.com/assets/pdf-gen/templates/md-64554.html';
      case 'E93CACCD-C644-4FE8-AF48-23AA8654E09A':
        // Pre-Wellness Plus Checklist
        // MD.64528
        return 'https://mdvipsf.seprint.com/assets/pdf-gen/templates/md-64528.html';
      case '7921B000-B0AB-4AAE-8B5E-E252292595DD':
        // Women's Health Pre-Wellness Checklist
        // MD.64546
        return 'https://mdvipsf.seprint.com/assets/pdf-gen/templates/md-64546.html';
      case 'MD64612':
        // Women’s Health Program Referral Cards
        // MD.64612
        return 'https://mdvipsf.seprint.com/assets/pdf-gen/templates/md-64612.html';
      case 'A2C21292-3572-44B7-8CEB-F6929DB254FF':
        // Referral Cards With Appointment Card
        // MD.52408
        return 'https://mdvipsf.seprint.com/assets/pdf-gen/templates/md-52408.html';
      case '49D4F31D-1A5B-435F-9094-070063F47B26':
      case 'MD52410':
        // Referral Cards Without Appointment Card
        // MD.52409
        return 'https://mdvipsf.seprint.com/assets/pdf-gen/templates/md-52409.html';
      case 'MDVIP-Invitation':
        // Invitation
        return 'https://mdvipsf.seprint.com/assets/pdf-gen/templates/invitation-v2.html';
      case 'A678D8E2-AD56-4B10-BB5B-08142796E227':
        // Membership giveaway
        return 'https://mdvipsf.seprint.com/assets/pdf-gen/templates/md-52424.html';
      default:
        return '';
    }
  }

  }
